import React from 'react';

import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import { Box, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';

import { getSignedCurrencyPrefix } from '~/components/Purchases/OrderDetail/OrderItem/utils';

interface Props {
  title: string;
  children: React.ReactNode;
}

export default function CogsAdjustmentBanner({ title, children }: Props) {
  return (
    <Box
      role="status"
      sx={{
        width: '100%',
        px: 1.5,
        py: 1,
        borderRadius: 0.75,
        bgcolor: (theme) => alpha(theme.palette.warning.main, 0.08),
        border: 1,
        borderColor: (theme) => alpha(theme.palette.warning.main, 0.4),
      }}
    >
      <Stack direction="row" alignItems="flex-start" gap={1.25}>
        <WarningAmberOutlinedIcon color="warning" fontSize="small" sx={{ mt: 0.25 }} />
        <Box>
          <Typography variant="subtitle2" fontWeight={700} color="warning.dark">
            {title}
          </Typography>
          <Typography variant="body2" color="text.primary">
            {children}
          </Typography>
        </Box>
      </Stack>
    </Box>
  );
}

interface VccBannerProps {
  amount: number;
  currencyCode?: string;
}

export function CogsAdjustmentVccBanner({ amount, currencyCode }: VccBannerProps) {
  const signedAmount = `${getSignedCurrencyPrefix(amount)}${amount.toFixed(2)}`;

  return (
    <CogsAdjustmentBanner title="VCC balance will not be updated.">
      This item has an approved COGS adjustment of {signedAmount} {currencyCode}. If the booking has a VCC, finance must
      adjust it manually.
    </CogsAdjustmentBanner>
  );
}
